import { render, staticRenderFns } from "./SelectSearchBase.vue?vue&type=template&id=0aa13977&"
import script from "./SelectSearchBase.vue?vue&type=script&lang=js&"
export * from "./SelectSearchBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports